<template>
  <div class="error-page">
    <img
      src="@/assets/images/tapkit-logo-black.png"
      alt="Tapkit logo"
      class="error-page__logo"
    >

    <img
      src="@/assets/images/error-cat.gif"
      alt="Eror image"
      class="error-page__media"
    >

    <h2 class="error-page__title">
      Nothin’ to tap here
    </h2>

    <p class="error-page__text error-page__text--bold">
      The page you’re looking for could not be found.
    </p>

    <p class="error-page__text">
      Please ensure you’ve typed the URL correctly.
    </p>

    <div class="error-page__action-block">
      <p class="error-page__text error-page__text--bold">
        Create your tapkit today
      </p>

      <button
        class="error-page__cta"
        @click="onCtaClicked()"
      >
        <span class="cta-text">Tapkit</span>
        <arrow-right-icon />
      </button>
    </div>
  </div>
</template>

<script>
import { ArrowRightIcon } from 'vue-feather-icons'
import config from '@/config/config'

export default {
  name: 'NotFoundErrorPage',
  components: {
    ArrowRightIcon
  },
  methods: {
    onCtaClicked () {
      window.location = `https://${config.ROOT_DOMAIN}/?source=404_page`
    }
  }
}
</script>

<style scoped lang="scss">
.error-page {
  display: flex;
  align-items: center;
  flex-direction: column;

  min-height: 100vh;
  padding: 100px 0 0;

  @include for-phone {
    padding: 60px 16px;
  }

  &__logo {
    margin: 0 0 60px;
  }

  &__media {
    margin: -60px 0 0;
    width: 340px;

    @include for-phone {
      width: 300px;
    }
  }

  &__title {
    color: #7015F9;
    font-size: 48px;
    line-height: 48px;
    margin: 0 0 24px;

    @include for-phone {
      font-size: 36px;
      text-align: center;
    }
  }

  &__text {
    font-size: 22px;
    line-height: 1.4;

    @include for-phone {
      font-size: 16px;
      text-align: center;
      max-width: 80%;
    }

    &--bold {
      font-weight: 600;
    }
  }

  &__action-block {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 40px 0 0;
    width: 100%;
  }

  &__cta {
    background: #6807F9;
    border-radius: 60px;
    color: #fff;
    font-size: 18px;

    display: flex;
    align-items: center;
    justify-content: center;

    height: 60px;
    margin: 16px 0 0;
    width: 260px;

    .cta-text {
      margin: 0 8px 0 0;
    }
  }
}
</style>
